import Shipping from "../../Shipping/Shipping";
import Modal from "../Modal";
import { useState } from "react";
import { useTranslation } from "../../../hooks/useTranslation";

export default function ShippingDetailModal({
  show,
    handleClose,
  tracking_id,
  shipping_company,
  title,
}) {
  const { t } = useTranslation();
  return (
    <Modal title={title} show={show} handleClose={handleClose} width="800px">
      {tracking_id &&
        tracking_id !== "" &&
        shipping_company &&
        shipping_company !== "" && (
          <Shipping
            tracking_id={tracking_id}
            shipping_company={shipping_company}
          />
        )}
    </Modal>
  );
}
